import { TopModel } from '@goldwasserexchange/react-topmodel';
import * as React from 'react';
import {
  NewsLetterBoxContent,
  NewsLetterBoxContentTopModels,
} from '../../../../../../../../../../../../../NewsletterBox';
import { NewsLetterBoxSubTitleContent } from '../../../../../../../../../../../../../NewsletterBox/components/title/components';
import {
  ArticleNewsLetterBoxInputContent,
  ArticleNewsLetterBoxSubTitleContainer,
  ArticleNewsLetterBoxTitleContainer,
  ArticleNewsLetterBoxTitleContent,
  ArticleNewsLetterBoxFormContentContainer,
  ArticleNewsLetterBoxFormSubmitButtonWrapper,
  ArticleNewsLetterBoxFirstNameInputContainer,
  ArticleNewsLetterBoxEmailInputContainer,
  ArticleNewsLetterBoxLastNameInputContainer,
} from './components';

const newsSidebarNewsLetterTopModels: NewsLetterBoxContentTopModels = {
  titleContainer: <TopModel name="titleContainer">{ArticleNewsLetterBoxTitleContainer}</TopModel>,
  titleContent: <TopModel name="titleContent">{ArticleNewsLetterBoxTitleContent}</TopModel>,
  subTitleContainer: <TopModel name="subTitleContainer">{ArticleNewsLetterBoxSubTitleContainer}</TopModel>,
  subTitleContent: <TopModel name="subTitleContent">{NewsLetterBoxSubTitleContent}</TopModel>,
  formContentContainer: <TopModel name="formContentContainer">{ArticleNewsLetterBoxFormContentContainer}</TopModel>,
  inputContent: <TopModel name="inputContent">{ArticleNewsLetterBoxInputContent}</TopModel>,
  formSubmitButtonWrapper: <TopModel name="formSubmitButtonWrapper">{ArticleNewsLetterBoxFormSubmitButtonWrapper}</TopModel>,
  'inputContainer-firstName': (
    <TopModel name="imputContainer-firstName">
      {ArticleNewsLetterBoxFirstNameInputContainer}
    </TopModel>
  ),
  'inputContainer-lastName': (
    <TopModel name="imputContainer-lastName">
      {ArticleNewsLetterBoxLastNameInputContainer}
    </TopModel>
  ),
  'inputContainer-email': (
    <TopModel name="inputContainer-email">
      {ArticleNewsLetterBoxEmailInputContainer}
    </TopModel>
  ),
};

export const NewsSidebarNewsLetter = () => (
  <div>
    <NewsLetterBoxContent
      topModels={newsSidebarNewsLetterTopModels}
    />
  </div>
);
